<div class="input-wrapper w100">
  <input
    #input
    class="h--38 w100"
    [value]="_value()"
    [attr.inputmode]="inputmode"
    [placeholder]="placeholder"
    [style.height]="getHeight()"
    pInputText
    [type]="(isPasswordRevealed$ | async) ? 'text' : 'password'"
    (input)="onInputChanged()"
    (paste)="onPasswordPaste($event)"
  />
  <div
    class="reveal-password-button"
    [class]="{ clickable: !isDisabled(), disabled: isDisabled() }"
    (click)="togglePasswordReveal()"
  >
    @switch (isPasswordRevealed$ | async) {
      @case (false) {
        <i class="pi pi-eye"></i>
      }
      @case (true) {
        <i class="pi pi-eye-slash"></i>
      }
    }
  </div>
</div>
